<template>
    <el-card :body-style="{ padding: '0.5rem 1rem 1rem 1rem', }" 
        :class="[
            'image-item-card',
            $machineListStyle[element.status],
            element.checked ? 'image-item__checked' : 'image-item__unchecked',
            element.isDemo ? 'image-item__is-demo' : 'image-item__is-normal',
            element.isDemoMachineDisabled ? 'image-item__demo-expired' : '',
        ]"
        shadow="always">
        <div class="d-flex flex-column">
            <div class="d-flex flex-row justify-content-between align-items-center machine-item">
                <div class="d-flex flex-row align-items-center" style="font-family: Montserrat">
                    <div class="d-flex justify-content-center align-items-center dotted-indicator" 
                        :class="`${element.status === 32773 || element.status === 10 ? 'blink_me' : '' }`" 
                        style=" border-radius: 1rem; height: 0.75rem; width: 0.75rem; " 
                        :style="`background-color: ${$machineStatusDotColor[element.status ] };`"></div>
                    <div class="ml-2 row-index-label">
                        # {{ index + 1 }}
                    </div>
                    <div v-if="element.isDemo"  class="ml-2">
                        <span class="demo-image-label">
                            <i class="ri-flask-line" style="font-size: 120%;"></i>
                            <span class="ml-1">DEMO</span>
                            <span class="ml-1"> 
                                <i class="ri-arrow-drop-right-line"></i> 
                                <span>&nbsp;Time left:&nbsp;&nbsp;<strong>{{element.demoRemainingSeconds | secondDuration}}</strong></span>
                            </span>
                        </span>
                    </div>
                    <div v-if="element.isNotSupport" class="ml-2">
                        <div class="not-support-label">
                            <i class="el-icon-close"></i>
                            <span class="ml-2">Not available, please change package</span>
                        </div>
                    </div>
                    <div v-else class="d-flex flex-row">
                        <div v-if="element.hardwareFixation " class="ml-2 hardwareFixation">
                            <i class="fas fa-thumbtack"></i>
                            <span class="ml-2">Fixed MAC</span>
                        </div>
                        <div v-if="element.softwareLicenseEnabled " class="ml-2 softwareLicenseEnabled">
                            <i class="el-icon-key"></i>
                            <span class="ml-2">License</span>
                        </div>
                        <div v-if="element.fixedRental" class="ml-2 fixedRental">
                            <i class="el-icon-date"></i>
                            <span class="ml-2">Rental Plan</span>
                        </div>
                        <div v-if=" element.isDisconnectedInternet " class="ml-2 isDisconnectedInternet">
                            <i class="el-icon-date"></i>
                            <span class="ml-2">Disconnected
                                Internet</span>
                        </div>
                        <el-tooltip class="item" effect="dark" 
                            :content="`Shutdown at : ${actions.formatTime( element.schedulerMachineShutdownMachineStartAt )}`" 
                            placement="top">
                            <div v-if=" element.schedulerMachineShutdownMachineEnabled " class="ml-2 schedulerMachineShutdownMachineEnabled">
                                <i class="el-icon-switch-button"></i>
                                <span class="ml-1">
                                    {{ element.schedulerMachineShutdownMachineTimeRemaining }}
                                </span>
                            </div>
                        </el-tooltip>
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center" style="column-gap: 0.5rem;">
                    <div v-if="!element.isDemo && element.fixedRental" class="d-flex flex-row align-items-center" style="column-gap: 0.5rem;"> 
                        <div v-if="element.cashbackAmount" class="info-machine-text">
                            <span>Plan Period&nbsp;&nbsp;</span>
                            <strong  style="color: #ED8A34;">{{ element.duration }}</strong>
                            <span>&nbsp;/&nbsp;</span>
                            <strong>{{ element.fixedRentalDuration }}</strong>
                        </div>
                        <span v-if="element.fixedRentalSpent">-</span>
                        <div v-if="element.fixedRentalSpent" class="info-machine-text d-flex flex-row align-items-center">
                            <span>Total cost&nbsp;&nbsp;</span>
                            <strong class="d-flex flex-row align-items-center" style="color: #ED8A34;">
                                <span>-{{ element.fixedRentalSpent }}</span> <ir-point color="#ED8A34" size="10px"/>
                            </strong>
                        </div>
                        <span v-if="element.cashbackAmount">-</span>
                        <div v-if="element.cashbackAmount" class="info-machine-text d-flex flex-row align-items-center">
                            <span>Credit back&nbsp;&nbsp;</span>
                            <strong class="d-flex flex-row align-items-center" style="color: #529421;">
                                <span>+{{ element.cashbackAmount }}&nbsp;</span><ir-point color="#529421" size="10px"/>
                            </strong>
                        </div>
                    </div>
                    <div v-if="!element.isDemo && !element.fixedRental" 
                        class="d-flex flex-row align-items-center" style="column-gap: 0.5rem;"> 
                        <div v-if="element.estimatedCreditback" class="info-machine-text">
                            <span>Usage time&nbsp;&nbsp;</span>
                            <strong  style="color: #ED8A34;">{{ element.duration }}</strong>
                        </div>
                        <span v-if="element.estimatedTotal">-</span>
                        <div v-if="element.estimatedTotal" class="info-machine-text d-flex flex-row align-items-center">
                            <span>Pay as you go&nbsp;&nbsp;</span>
                            <strong  style="color: #ED8A34;">-{{ element.estimatedTotal }} <ir-point style="margin-bottom: 2px;" color="#ED8A34" size="9px"/></strong>
                        </div>
                        <span v-if="element.estimatedCreditback">-</span>
                        <div v-if="element.estimatedCreditback" class="info-machine-text d-flex flex-row align-items-center">
                            <span>Credit back&nbsp;&nbsp;</span>
                            <strong  style="color: #529421;">+{{ element.estimatedCreditback }} <ir-point style="margin-bottom: 2px;" color="#529421" size="9px"/></strong>
                        </div>
                    </div>
                    <div v-if="element.status !== 2" class="vhdxLength">
                        {{ element.vhdxLength | formatSize }}
                    </div>
                    <ContextMenu class="ml-2" :element="element" @processingEvent="actions.processingEvent " />
                </div>
            </div>
            <div class="d-flex flex-row pt-3 mt-2 border-spliter-header">
                <div class="hidden-sm-and-down mr-5">
                    <Lable :element="element" />
                </div> 
                <Information :element="element" />
                <div style="display: flex" class="hidden-sm-and-down align-items-end">
                    <Action :element="element" @processingEvent="actions.processingEvent " />
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import Lable from "@/views/component/RentalService/Lable";
import ContextMenu from "@/views/component/RentalService/ContextMenu";
import Action from "@/views/component/RentalService/Action";
import Information from "@/views/component/RentalService/Information";
export default {
    components: {        
        Action,
        Lable,
        ContextMenu,
        Information,
    },
    props :{ 
        element: {
            type: Object,
            default() {
                return {}
            }
        },
        index: {
            type: Number,
            default() {
                return -1
            }
        },
        actions: {
            type: Object,
            default() {
                return {}
            }
        },
    }
}
</script>